import { Colors } from '@/common/colors/colors';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import Input from '@/common/components/Input';
import PopUp from '@/common/components/PopUp';
import moment from 'moment';
import { useRef } from 'react';
import { Form, Header } from './PopUp.styled';

export default function AcceptPopUp({ setShow, handleSubmit }) {
	const dateRef = useRef();

	const onSubmit = (event) => {
		event.preventDefault();
		const date = dateRef.current.value;
		handleSubmit(moment(date).format('DD-MM-YYYY'));
	};

	return (
		<PopUp setShow={setShow}>
			<Header>Positive decision</Header>
			<Form onSubmit={onSubmit}>
				<Input
					name='Start date'
					width={100}
					color={Colors.darkBlue}
					inputRef={dateRef}
					type='date'
					inputWidth={140}
					required
				/>
				<SubmitButton
					text='Send email'
					color={Colors.darkBlue}
					style={{ alignSelf: 'flex-end' }}
				/>
			</Form>
		</PopUp>
	);
}
